const CURRENCY_NAMES = {
    rub: 'Российский рубль',
    usd: 'Доллар США',
    eur: 'ЕВРО',
    gbp: 'Фунт стерлингов',
    cny: 'Китайский юань',
    chf: 'Швейцарский франк',
    try: 'Турецкая лира',
    aed: 'Дирхам ОАЭ',
};
const CURRENCY_SIGNS = {
    rub: '&#8381;',
    usd: '$',
    eur: '&euro;',
    gbp: '&pound;',
    cny: '&yen;',
    chf: '&#x20a3;',
    try: '&#8378;',
    aed: '&#1583;',
};
const RUB = 'rub';
const CNY = 'cny';
const DI_CURRENCY_CODES = ['CNY', 'CHF', 'GBP'];
const BLOCKED_CURRENCY_CODES = ['CHF', 'GBP'];
const ALLOWED_CURRENCY_CODES = {
    OFFICE: ['EUR', 'CNY', 'CHF', 'GBP'],
    INTERNET: ['EUR', 'USD', 'EUR/RUR', 'USD/RUR', 'EUR/USD', 'CNY'],
    SCREEN: ['EUR', 'CNY', 'CHF', 'GBP'],
    MAIN_PAGE: ['EUR', 'CNY'],
    OTHER: ['EUR/RUR', 'USD/RUR'],
};

export default {
    CURRENCY_NAMES,
    CURRENCY_SIGNS,
    CNY,
    RUB,
    DI_CURRENCY_CODES,
    BLOCKED_CURRENCY_CODES,
    ALLOWED_CURRENCY_CODES,
};
